export default "__VITE_ASSET__BU16uO7W__"